import { render, staticRenderFns } from "./EditBrochure.vue?vue&type=template&id=280c97ea&lang=pug&"
import script from "./EditBrochure.vue?vue&type=script&lang=ts&"
export * from "./EditBrochure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports